import React from 'react'
import { StyleSheet, Text } from 'react-native'

interface HeaderProps {
  children: string
}

export default function ({ children }: HeaderProps) {
  return (
    <Text style={styles.header}>{ children }</Text>
  )
}

const styles = StyleSheet.create({
  header: {
    fontSize: 24,
    fontWeight: '700',
    color: '#333',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
})
